export default __webpack_public_path__ + "static/gwp-sub-banner-desktop-19595400105952b7a90b823c15c030b8.webp";